import React from 'react';
import { UserMenu } from './UserMenu';
// @ts-ignore
import logoART from '../assets/ART.png';
// @ts-ignore
import logoDSCI from '../assets/DSCI.png';
import parthenon from '../assets/parthenon.svg';

export const InstitutionalHeader: React.FC = () => (
  <div className="w-full bg-white border-b border-gray-200 px-6 md:px-16 py-4">
    <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-6 gap-4 items-center">

      {/* Col 1 — Logo ART */}
      <div className="col-span-1 flex items-center">
        <img src={logoART} alt="Agencia de Renovación del Territorio" className="max-h-12 w-full object-contain object-left" />
      </div>

      {/* Col 2 — Logo DSCI */}
      <div className="col-span-1 flex items-center">
        <img src={logoDSCI} alt="DSCI" className="max-h-12 w-full object-contain object-left" />
      </div>

      {/* Col 3-4 — Ícono + Título + Subtítulo (fila completa en mobile) */}
      <div className="col-span-2 md:col-span-2 flex items-center gap-3">
        <img src={parthenon} alt="" aria-hidden="true" className="h-12 w-auto shrink-0" />
        <div>
          <h1 className="text-lg font-bold text-[#0a0c46] leading-tight">
            Biblioteca PQRSD
          </h1>
          <p className="text-xs text-[#0a0c46]/70" style={{ fontFamily: 'Verdana, Geneva, sans-serif' }}>
            Sistema de Gestión de Conocimiento
          </p>
        </div>
      </div>

      {/* Col 5-6 — Menú de usuario, alineado al extremo derecho */}
      <div className="col-span-2 md:col-span-2 flex justify-end">
        <UserMenu />
      </div>

    </div>
  </div>
);
